import {
	Box,
	Typography,
	useMediaQuery,
} from "@mui/material";

import { appBreadCumbStyles, appHeaderStyles, colors, defaultStyles } from "@components/ThemeRegistry/theme";
import { FC, useContext } from "react";
import { AuthorizationContext } from "@components/AuthorizationContext";
import { IBreadCrumbLink } from "@definitions/index";
import { CustomLink } from "@components/CustomLink";
import { borderBottomProps } from "@styles/global-css-class";
export const AppBreadcrumb: FC<{
	links: IBreadCrumbLink[];
	marginBottom?: string | number;
	useAppPadding?: boolean;
}> = ({ links, marginBottom = "19px", useAppPadding = false }) => {
	const authenticatedContext = useContext(AuthorizationContext);
	const Z_INDEX = 1000;
	const linkStyle = {
		fontWeight: 400,
		fontSize: "15px",
		lineHeight: "17px",
	};
	const linkStyleBold = {
		fontWeight: 600,
		fontSize: "15px",
		lineHeight: "17px",
	};

	const redirectToHome = (e: any) => {
		authenticatedContext.setCallbackRedirect(() => {
			if (typeof window !== 'undefined' && location) {
				location.href = "/"
			}
		});
		if (!authenticatedContext.unsavedChange) {
			if (typeof window !== 'undefined' && location) {
				location.href = "/"
			}
		}
		if (authenticatedContext.callbackUnSavedChange) {
			authenticatedContext.callbackUnSavedChange();
		}
		e.preventDefault();
	};
	const isMobile = useMediaQuery('(max-width:1024px)');
	return (
		<>
			<Box sx={{
				...borderBottomProps,
				minHeight: appBreadCumbStyles.minHeight,
				maxHeight: appBreadCumbStyles.maxHeight,
				paddingLeft: useAppPadding ? defaultStyles.appPaddingLeft : 0,
				paddingRight: useAppPadding ? defaultStyles.appPaddingRight : 0,
				alignContent: "center",
				position: 'sticky',
				top: 0,
				zIndex: Z_INDEX+2,
				bgcolor: 'white',
				minWidth:defaultStyles.appPageMinWidth
			}}>
				<Box sx={{
					display: appBreadCumbStyles.display,
					minHeight: appBreadCumbStyles.minHeight,
					paddingX: defaultStyles.pagePaddingX
				}}>
					<Box sx={{
						display: "flex",
						alignItems: "center",
					}}>
						<Typography sx={{
							fontWeight: 400,
							fontSize: "15px",
							lineHeight: "17px",
							cursor: "pointer",
						}} onClick={redirectToHome}>
							Home
						</Typography>
					</Box>
					{
						links?.map((link, index) => {
							return link.href ? (
								<Box
									key={index}
									sx={{
										display: "flex",
										alignItems: "center",
									}} >
									<CustomLink
										href={link.href}
										sx={{
											...linkStyle,
											textDecoration: "none",
											textTransform: "none",
											color: colors.black
										}}
									>
										<Typography sx={index == links?.length - 1 ? linkStyleBold : linkStyle} >
											<span>&nbsp;</span> / {link.text}
										</Typography>
									</CustomLink>
								</Box>
							) : <Box
								key={index}
								sx={{
									display: "flex",
									alignItems: "center",
								}} >
								<Typography sx={index == links?.length - 1 ? linkStyleBold : linkStyle} >
									<span>&nbsp;</span> / {link.text}
								</Typography>
							</Box>;
						})
					}
				</Box>
			</Box >
			{/*Below content margin*/}
			<Box marginTop={marginBottom}></Box>
		</>

	);
};
